import { handleResponse } from './common';

const API_URL = process.env.GATSBY_API_URL;

export const aiService = {
  generateGreetingMessage,
};

async function generateGreetingMessage(payload = {}, signal) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    signal,
  };

  return handleResponse(`${API_URL}/openai/greeting`, requestOptions);
}
